export default __webpack_public_path__ + "static/media/whatsapp.096d5d7a.png";